// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OUM2","delete":"styles_delete__2-u3f","update":"styles_update__31eJq","add":"styles_add__G_sa9"};